export function getGreeting(preferredName?: string | null, isFirstVisit?: boolean): string {
  // Show "Welcome, [Name]" for first visit after onboarding
  if (isFirstVisit && preferredName && preferredName.trim()) {
    const displayName = truncateName(preferredName)
    return `Welcome, ${displayName}`
  }

  // Regular time-of-day greeting
  const hour = new Date().getHours()

  let timeGreeting: string
  if (hour < 12) {
    timeGreeting = "Good morning"
  } else if (hour < 17) {
    timeGreeting = "Good afternoon"
  } else {
    timeGreeting = "Good evening"
  }

  if (preferredName && preferredName.trim()) {
    const displayName = truncateName(preferredName)
    return `${timeGreeting}, ${displayName}`
  }

  // Fallback when no name available
  return "Your AI Business Advisor"
}

function truncateName(name: string, max = 20): string {
  if (name.length <= max) return name
  return name.slice(0, max - 3) + "..."
}
